<template>
  <div id="userlist">
    <el-card class="box-card">
        <div slot="header" class="clearfix">
            <span>商城用户&nbsp;/&nbsp;用户列表</span>
        </div>
        <div style="display: flex;flex-wrap: wrap;align-items: center;">
       <el-input class="elinputs" v-model="beginData.nickname" placeholder="昵称"></el-input>
       <el-input class="elinputs" v-model="beginData.mobile" placeholder="手机号"></el-input>
       <el-input class="elinputs" v-model="beginData.id" placeholder=" 用户编号"></el-input>
        <el-select v-model="beginData.gender" placeholder="性别选择" class="elinputs">
            <el-option v-for="item in beginData.sexs" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
        </el-select>
        <el-button type="primary" element-loading-text="加载中..." element-loading-background="rgba(0, 0, 0, 0.4)" v-loading.fullscreen.lock="fullscreenLoading" @click="query">查询</el-button>
        <el-button type="info" @click="resets">重置</el-button>
        </div>
        <div class="tit">
          <el-button type="info" size="small" class="all_btn" icon="el-icon-warning-outline" @click="reset">刷新</el-button>
          <Xlsx :name="formname"></Xlsx>
        </div>
        <el-table :data="tableData" id="exportTab" border stripe style="width: 100%">
        <el-table-column type="index" label="序号" width="80" :index="1"></el-table-column>
        <el-table-column prop="id" label="用户编号" width="120"></el-table-column>
        <el-table-column prop="nickname" label="昵称" width="160"></el-table-column>
        <el-table-column min-width="120" label="头像">
            <template slot-scope="scope">
            <viewer>
                <img class="sfzimg" :src="scope.row.avatar" />
            </viewer>
            </template>
        </el-table-column>
        <el-table-column label="性别" sortable width="100">
            <template slot-scope="scope">
                <p class="boldfont" v-if="scope.row.gender==1">男</p><p class="boldfont" v-if="scope.row.gender==2">女</p>
            </template>
        </el-table-column>
        <el-table-column prop="mobile" label="手机号" width="160"></el-table-column>
        <el-table-column prop="money" label="账户余额（元）" sortable width="160"></el-table-column>
        <el-table-column prop="consumeMoney" label="消费总额（元）" sortable width="160"></el-table-column>
        <el-table-column label="状态" width="110">
            <template slot-scope="scope">
                <p class="boldfont" v-if="scope.row.status==0">可用</p>
                <p class="boldfont" v-if="scope.row.status==1" style="color:#F56C6C">禁用</p>
                <p class="boldfont" v-if="scope.row.status==2" style="color:#F56C6C">注销</p>
            </template>
        </el-table-column>
        <el-table-column prop="addTime" label="注册时间" width="180"></el-table-column>

        <el-table-column label="操作" fixed="right" min-width="360">
            <template slot-scope="scope">
            <el-button size="mini" type="success" @click="handleEdit(1,scope.row,'userlist:recharge')"><i class="el-icon-document-add"></i> 余额充值</el-button>
            <el-button size="mini" type="warning" @click="handleEdit(2,scope.row,'userlist:rechargeLog')"><i class="el-icon-document"></i> 充值记录</el-button>
            <el-button size="mini" type="danger" @click="handleEdit(3,scope.row,'userlist:consumptionLog')"><i class="el-icon-document-delete"></i> 消费记录</el-button>
            </template>
        </el-table-column>
        </el-table>
        <div class="paging">
            <span>
            共
            <i class="pagingNum">{{total}}</i> 条
            </span>
            <Paging :gopage="total" @pag="pag"></Paging>
        </div>
    </el-card>
    <el-dialog :title="mydata.name" :visible.sync="dialogFormVisible" width="60%">
        <el-form v-if='mydata.stat == 1'>
            <el-form-item label="* 昵称：">
                <p>{{mydata.nickname}}</p>
            </el-form-item>
            <el-form-item label="* 电话号码：">
                <p>{{mydata.mobile}}</p>
            </el-form-item>
            <el-form-item label="* 充值金额：">
               <el-input placeholder="请输入充值金额（元）" type="number" v-model="mydata.moneys" auto-complete="off"></el-input>
            </el-form-item>
        </el-form>
        <el-form v-else>
          <!-- 充值记录 -->
            <el-table :data="tableData2" border style="width: 100%" v-if="mydata.stat == 2">
                <el-table-column type="index" label="序号" width="80" :index="1"></el-table-column>
                <el-table-column label="充值金额（元）">
                  <template slot-scope="scope">
                    <p class="boldfont" v-if="scope.row.type == 2">{{scope.row.money}}</p>
                    <p class="boldfont" v-if="scope.row.type == 5">{{scope.row.wxMoney}}</p>
                  </template>
                </el-table-column>
                <el-table-column label="充值类型">
                  <template slot-scope="scope">
                    <p class="boldfont" v-if="scope.row.type == 2" style="color:#ff9800">后台充值</p>
                    <p class="boldfont" v-if="scope.row.type == 5" style="color:#1FBCA7">用户充值</p>
                  </template>
                </el-table-column>
                <el-table-column prop="date" label="充值时间"></el-table-column>
            </el-table>
            <!-- 消费记录 -->
            <el-table :data="tableData2" border style="width: 100%" v-else>
                <el-table-column type="index" label="序号" width="80" :index="1"></el-table-column>
                <el-table-column prop="money" label="消费金额（元）">
                </el-table-column>
                <el-table-column prop="date" label="消费时间">
                </el-table-column>
            </el-table>
            <div class="paging">
                <span>共<i class="pagingNum">{{textdata.total}}</i> 条</span>
                <Paging :gopage="textdata.total" @pag="pags"></Paging>
                <!-- <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="textdata.pageNum" :page-sizes="[10, 30, 50, 100]" :page-size="textdata.pageSize"
                layout="sizes, prev, pager, next" :total="textdata.total"></el-pagination> -->
            </div>
        </el-form>
        <div slot="footer" class="dialog-footer" v-if='mydata.stat == 1'>
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="puton">确 定</el-button>
        </div>
    </el-dialog>
  </div>
</template>
<script>
import Xlsx from "@/components/Xlsx";
import EditorBar from '@/components/Richtext';
import Paging from '@/components/Paging';
export default {
  name: "userlist",
  components: {
    Xlsx,
    EditorBar,
    Paging
  },
  data() {
    return {
        beginData:{sexs:[{id:0,name:'男'},{id:1,name:'女'}]},
        tableData: [],
        tableData2:[],
        pageNum: 1,
        pageSize: 10,
        dialogFormVisible: false,
        details:[],
        userdata: {},
        total: 0,
        btn: [],
        areaId: "",
        fullscreenLoading: true,
        formname: JSON.stringify({name:'用户列表',hint:'userlist:export'}),
        imgUrl: this.$Public.imgUrl,
        isClear: false,
        sheng:'',
        shi:'',
        shenglist:[],
        shilist:[],
        mydata:{},
        textdata:{pageNum:1,pageSize:10,total:0},
        multipleSelection:[]
    };
  },
  created() {
    let btn = JSON.parse(sessionStorage.getItem("btn"));
    this.$set(this, "btn", btn);
    this.begin();
  },
  computed: {
    data() {
      return this.tableData;
    }
  },
  mounted() {
  },
  methods: {
    //   确定
    puton(){
        if(this.mydata.moneys==undefined){
          return this.$message('请输入充值金额')
        }
        if(Number(this.mydata.moneys)<0){
          return this.$message('请输入正确的充值金额')
        }
        // 判断是点击哪个
        let data = {
            adminId:this.userdata.id,
            money:this.mydata.moneys,
            userId:this.mydata.id
        }
        this.$axios.post(`/api-s/recharge`,this.$qs.stringify(data),{ headers: { accessToken: this.userdata.token } })
        .then(res => {
            if(res.data.success){
              this.$message({
                  type: 'success',
                  message: res.data.msg
              });
              this.dialogFormVisible = false
              this.begin()
            }else{
              this.$message(res.data.msg)
            }
        });
    },
    resets(){
        this.$router.push('/refresh')
    },
    reset() {
      this.begin();
    },
    // handleSizeChange(val) {
    //   this.pageSize = val;
    //   this.fullscreenLoading = true;
    //   this.begin();
    // },
    // handleCurrentChange(val) {
    //   this.pageNum = val;
    //   this.fullscreenLoading = true;
    //   this.begin();
    // },
    pag(val){
        this.pageNum = val.pageNum
        this.pageSize = val.pageSize
        this.fullscreenLoading = true;
        this.begin();
    },
    pags(val){
        this.textdata.pageNum = val.pageNum
        this.textdata.pageSize = val.pageSize
        this.fullscreenLoading = true;
        this.handleEdit(this.mydata.stat,this.mydata)
    },
    begin() {
      let userdata = JSON.parse(sessionStorage.getItem("userdata"));
      this.$set(this, "userdata", userdata);
      let data = this.$qs.stringify({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        id:this.beginData.id,
        mobile:this.beginData.mobile,
        nickname:this.beginData.nickname,
        areasid: userdata.areasId
      });
      this.$axios.post(`/api-s/getUserList`, data, {headers: { accessToken: userdata.token }})
        .then(res => {
            this.fullscreenLoading = false;
            if(res.data.success){
                this.$nextTick(function(){  //不使用this.$nextTick()方法会报错
                    this.$set(this, "tableData", res.data.pageInfo.list);
                });
                this.$set(this, "total", res.data.pageInfo.total);
                this.$message({
                    type: 'success',
                    message: res.data.msg
                });
            }else{
              this.$message(res.data.msg)
            }
        });
    },
    handleEdit(i,row,hint) {
        if(hint&&this.btn.indexOf(hint)==-1){
            return this.$message('抱歉，用户暂无该权限')
        }
        row.stat = i
        if(i == 1){
            row.name = '余额充值'
        }else{
            let url = ``
            let data = this.$qs.stringify({
                  pageNum:this.textdata.pageNum,
                  pageSize:this.textdata.pageSize,
                  userId:row.id
                })
            if(i == 2){
                row.name = '充值记录'
                url = `/api-s/getUserRechargeLogList`
            }else{
                row.name = '消费记录'
                url = `/api-s/getUserConsumeLogList`
            }
            this.$axios.post(url,data,{ headers: { accessToken: this.userdata.token } })
            .then(res => {
                this.fullscreenLoading = false;
                this.tableData2 = res.data.pageInfo.list,
                this.textdata.total = res.data.pageInfo.total
            });
        }
        this.mydata = row
        this.dialogFormVisible = true
    },
    query() {
      this.fullscreenLoading = true;
      this.begin();
    }
  }
};
</script>
<style>
.w-e-toolbar{
  flex-wrap: wrap;
}
#userlist .el-input__inner {
  margin: 10px 0;
}
#userlist .el-menu.el-menu--horizontal{
  margin-bottom: 14px;
}
#userlist .el-menu-item.is-active{
  background: none
}
#userlist .el-pagination__sizes .el-input__inner {
  margin: 0;
}
#userlist .el-tag{
  margin-right: 12px;
}
#userlist .el-select {
  /* margin: 0 8px; */
}
#userlist .el-upload__tip {
    display: inline-block;
    margin-left: 14px;
}
.input-new-tag{
  width: 20%
}
#userlist .el-upload-list--picture .el-upload-list__item {
    width: 44%;
    float: left;
    margin-right: 2%;
}
#userlist .el-form-item__content {
    width: 100%;
}
#userlist .el-table td,
.el-table th.is-leaf {
  text-align: center;
}
/* 暂无数据样式 */
#userlist .el-table__empty-text {
  display: block;
  width: 500px;
  height: 240px;
  padding-top: 126px;
  background: url(../../assets/img/nothing.svg) no-repeat 50%;
  color: #909399;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 12px;
}
#userlist .myxx .el-input--suffix .el-input__inner {
  border-bottom: 1px solid #dcdfe6;
  margin-bottom: 20px;
}
#userlist .myxx .el-input__inner {
  padding: 0 11px;
  border: none;
  border-radius: 0;
}
#userlist .el-dialog__body {
  height:100%;
}
#userlist .el-form-item{
    display: flex;
    align-items: center;
    margin-bottom:0
}
#userlist .el-form-item__label{
    width: 122px
}
.viewer-transition {
  z-index: 9999 !important;
}
</style>
<style scoped lang="scss">
.clearfix{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.tit {
  display: flex;
  justify-content: space-between;
  margin: 16px 0 24px;
}
.sfzimg {
  height: 48px;
}
#help .myxx p {
  margin: 5px 0;
  font-size: 16px;
}
h5 {
  text-align: center;
  margin-top: 12px;
}
.f56 {
  background: #909399;
  color: #fff;
  border: 1px solid #909399;
}
.c23 {
  background: #409eff;
  color: #fff;
  border: 1px solid #409eff;
}
.tx{
      color: red;
    margin-left: 8px;
}
.summary>span:first-child{
    margin-right: 20px
}
.summary>span:first-child i{
    color:red
}
.summary>span:last-child i{
    color:green
}
.staimg{
    position: absolute;
    left: -26px;
    top: 10px;
    width: 18px;
}
.dtstat span{
    margin: 0 34px;
}
</style>
